(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    root.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    let current = 0;
    let paused = false;
    const motionToggle = document.createElement('button');
    motionToggle.type = 'button';
    motionToggle.className = 'sfc-motion-toggle';
    motionToggle.textContent = 'Pause animation';
    motionToggle.hidden = true;
    root.querySelector('.sfc-viewer').after(motionToggle);
    motionToggle.addEventListener('click', function () {
      paused = !paused;
      motionToggle.textContent = paused ? 'Play animation' : 'Pause animation';
      syncMotion();
    });
    const motionStates = panels.map(function (panel) {
      return {panel:panel, art:panel.querySelector('.sfc-art'), image:panel.querySelector('.sfc-illustration'), near:false, svg:null, loading:false, failed:false};
    });
    const controller = new AbortController();
    let disposed = false;
    function syncMotion() {
      motionToggle.hidden = reduced.matches || (!paused && !motionStates[current].svg);
      motionStates.forEach(function (state) {
        const play = state.near && !state.panel.hidden && !document.hidden && !reduced.matches && !paused && !disposed;
        if (state.svg) {
          state.svg.dataset.playing = String(play);
          return;
        }
        if (!play || state.loading || state.failed || !state.image) return;
        const url = new URL(state.image.currentSrc || state.image.src, location.href);
        if (!/fizzy-science-focus-(nutrition|immune|oxidative|mood|gut)\.svg$/.test(url.pathname)) return;
        url.pathname = url.pathname.replace(/\.svg$/, '-motion.svg');
        state.loading = true;
        fetch(url.href, {signal:controller.signal}).then(function (response) {
          if (!response.ok) throw new Error('Artwork unavailable');
          return response.text();
        }).then(function (markup) {
          if (disposed) return;
          const parsed = new DOMParser().parseFromString(markup, 'image/svg+xml');
          const svg = parsed.documentElement;
          if (svg.localName !== 'svg' || parsed.querySelector('parsererror')) throw new Error('Invalid artwork');
          // Only our authored vector files are loaded. Strip executable/foreign content.
          svg.querySelectorAll('script, foreignObject, iframe').forEach(function (node) { node.remove(); });
          [svg].concat(Array.from(svg.querySelectorAll('*'))).forEach(function (node) {
            Array.from(node.attributes).forEach(function (attr) {
              if (/^on/i.test(attr.name) || (/href$/i.test(attr.name) && attr.value[0] !== '#')) node.removeAttribute(attr.name);
            });
          });
          const host = document.createElement('div');
          host.className = 'sfc-illustration sfc-motion';
          host.setAttribute('aria-hidden', 'true');
          const shadow = host.attachShadow({mode:'open'});
          const sizing = document.createElement('style');
          sizing.textContent = ':host{display:block}svg{display:block;width:100%;height:100%}';
          shadow.append(sizing, document.importNode(svg, true));
          state.svg = shadow.querySelector('svg');
          state.image.before(host);
          state.image.hidden = true;
          syncMotion();
        }).catch(function (error) {
          if (error.name !== 'AbortError') state.failed = true;
        }).finally(function () { state.loading = false; });
      });
    }
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const state = motionStates.find(function (item) { return item.art === entry.target; });
        if (state) state.near = entry.isIntersecting && entry.intersectionRatio >= 0.15;
      });
      syncMotion();
    }, {threshold:0.15}) : null;
    if (observer) motionStates.forEach(function (state) { if (state.art) observer.observe(state.art); });
    document.addEventListener('visibilitychange', syncMotion);
    reduced.addEventListener('change', syncMotion);
    function cleanup(event) {
      if (!event.target.contains(root)) return;
      disposed = true;
      controller.abort();
      if (observer) observer.disconnect();
      document.removeEventListener('visibilitychange', syncMotion);
      reduced.removeEventListener('change', syncMotion);
      document.removeEventListener('shopify:section:unload', cleanup);
    }
    document.addEventListener('shopify:section:unload', cleanup);
    const topicRail = root.querySelector('.sfc-topics');
    function revealTab(tab) {
      if (!topicRail || topicRail.scrollWidth <= topicRail.clientWidth) return;
      const rail = topicRail.getBoundingClientRect();
      const item = tab.getBoundingClientRect();
      const inset = 20;
      let delta = 0;
      if (item.left < rail.left + inset) delta = item.left - rail.left - inset;
      else if (item.right > rail.right - inset) delta = item.right - rail.right + inset;
      if (delta) topicRail.scrollTo({left:topicRail.scrollLeft + delta, behavior:reduced.matches ? 'instant' : 'smooth'});
    }
    let animation;
    function select(index, animate) {
      if (animation) animation.cancel();
      current = (index + tabs.length) % tabs.length;
      tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-selected', String(i === current));
        tab.tabIndex = i === current ? 0 : -1;
        panels[i].hidden = i !== current;
      });
      revealTab(tabs[current]);
      syncMotion();
      if (animate && !reduced.matches && panels[current].animate) {
        animation = panels[current].animate([{opacity:.65},{opacity:1}],
          {duration:180,easing:'cubic-bezier(.2,.7,.3,1)'});
      }
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { if(index !== current) select(index, true); });
      tab.addEventListener('keydown', function (event) {
        let target;
        if(event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        if(event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
        if(event.key === 'Home') target = 0;
        if(event.key === 'End') target = tabs.length - 1;
        if(target !== undefined) {
          event.preventDefault(); select(target, false); tabs[target].focus({preventScroll:true});
        }
      });
    });
    select(0, false);
    root.addEventListener('shopify:block:select', function (event) {
      const index = tabs.indexOf(event.target.closest('[data-topic]'));
      if(index >= 0) select(index, false);
    });
  }
  function scan(scope) { scope.querySelectorAll('[data-science-focus]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();

/* Mobile topic rail: flag the rail once it is scrolled to the end so the CSS
   edge fade drops off and the last tab reads at full strength. Standalone and
   idempotent (theme-editor safe). 2026-09-16 UI/UX pass. */
(function () {
  function watch(rail) {
    if (!rail || rail.dataset.endWatch) return;
    rail.dataset.endWatch = '1';
    var sync = function () {
      var atEnd = rail.scrollWidth <= rail.clientWidth + 1 ||
                  rail.scrollWidth - rail.clientWidth - rail.scrollLeft <= 1;
      if (atEnd) rail.setAttribute('data-end', ''); else rail.removeAttribute('data-end');
    };
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    sync();
  }
  function init() { document.querySelectorAll('[data-science-focus] [role="tablist"]').forEach(watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
